module.exports = __webpack_public_path__ + "204dc3b4cfc70045896ec25e1e57c27b.pdf";